import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IMediaVr, IVrVideo } from '@core/models';
import { CdnUrlPipe } from '@shared/pipes';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@Component({
  selector: 'app-vr-card',
  imports: [LazyLoadImageModule, CdnUrlPipe],
  templateUrl: "./vr-card.component.html",
  styleUrl: "./vr-card.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VrCard {
  /** Variable de entrada que recibe la lista de videos y recorridos de realidad virtual*/
  readonly itemVr = input.required<IMediaVr>();

  protected readonly isVideo = computed<boolean>(() => this.itemVr().isVideo || false);

  protected redirecTo(): void {
    if (this.isVideo()) {
      const itemVr = this.itemVr() as IVrVideo;
      window.open('' + itemVr.web_link_youtube_video + '', '_blank');
      return;
    }

    const itemVr = this.itemVr();
    window.open('' + itemVr.url_content + '', '_blank');
  }
}
